import React from "react";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

export const renderVerdict = (probability) => {
  let color;
  let verdict;
  if (probability < 0.2) {
    color = { color: getPathogenicityColorByAllNames("benign") };
    verdict = "Very likely recessive";
  } else if (probability >= 0.2 && probability < 0.4) {
    color = {
      color: getPathogenicityColorByAllNames("uncertain significance"),
    };
    verdict = "Likely recessive";
  } else if (probability >= 0.4 && probability < 0.6) {
    color = {
      color: getPathogenicityColorByAllNames("uncertain significance"),
    };
    verdict = "Either dominant or recessive";
  } else if (probability >= 0.6 && probability < 0.8) {
    color = {
      color: getPathogenicityColorByAllNames("uncertain significance"),
    };
    verdict = "Likely dominant";
  } else if (probability >= 0.8) {
    color = { color: getPathogenicityColorByAllNames("pathogenic") };
    verdict = "Very likely dominant";
  }
  return (
    <b>
      <span data-testid="unil-domino-verdict" style={color}>
        {verdict}
      </span>
    </b>
  );
};
